import BackToTop from "./BackToTop.jsx";
import ReactDom from "react-dom";

export default function renderBackToTop() {
  document.querySelectorAll(".js-back-to-top-mount").forEach((mount, i) => {
    ReactDom.render(<BackToTop index={i} />, mount);
  });
}
